
export default {
  name: 'APLink',
  props: {
    href: {
      type: String,
      default: '#'
    },
    revalStatus: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      envToPrefix: {
        Production: '',
        ProdCopy: 'ps-',
        Integration: 'int-',
        Development: 'dev-',
        Developer: 'dev-'
      }
    }
  },
  computed: {
    adjustedHref() {
      return this.href.replace('://', `://${this.envToPrefix[window.__env.environment]}`)
    },
    revalidationStatus() {
      return this.$store.state.revalidationStatus
    }
  }
}
